var _circle, _path, _mask, _path2, _mask2, _path3, _line, _line2, _line3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaxTaskDark = function SvgFaxTaskDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#328847"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52389 12.2H21.477C21.6559 12.2 21.8009 12.345 21.8009 12.5239V18.0476C21.8009 18.2265 21.6559 18.3715 21.477 18.3715H8.5239C8.34501 18.3715 8.2 18.2265 8.2 18.0476V12.5239C8.2 12.345 8.34501 12.2 8.52389 12.2ZM7 12.5239C7 11.6823 7.68227 11 8.52389 11H21.477C22.3186 11 23.0009 11.6823 23.0009 12.5239V18.0476C23.0009 18.8892 22.3186 19.5715 21.477 19.5715H8.5239C7.68227 19.5715 7 18.8892 7 18.0476V12.5239Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_29674_94263",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 7.78942C10 7.35343 10.3534 7 10.7894 7H19.2106C19.6466 7 20 7.35343 20 7.78942V12H10V7.78942Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.78942C10 7.35343 10.3534 7 10.7894 7H19.2106C19.6466 7 20 7.35343 20 7.78942V12H10V7.78942Z",
    stroke: "white",
    strokeWidth: 2.4,
    mask: "url(#path-3-inside-1_29674_94263)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_29674_94263",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 22.2106C10 22.6466 10.3534 23 10.7894 23H19.2106C19.6466 23 20 22.6466 20 22.2106V15H10V22.2106Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22.2106C10 22.6466 10.3534 23 10.7894 23H19.2106C19.6466 23 20 22.6466 20 22.2106V15H10V22.2106Z",
    fill: "#328847",
    stroke: "white",
    strokeWidth: 2.4,
    mask: "url(#path-4-inside-2_29674_94263)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17.6,
    x2: 18,
    y2: 17.6,
    stroke: "white",
    strokeWidth: 0.800045
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19.1,
    x2: 18,
    y2: 19.1,
    stroke: "white",
    strokeWidth: 0.800045
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20.6,
    x2: 18,
    y2: 20.6,
    stroke: "white",
    strokeWidth: 0.800045
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaxTaskDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fax-task-dark.102a5424.svg";
export { ForwardRef as ReactComponent };